module.exports = __webpack_public_path__ + "static/media/Equity_iconlogo.8158fe40.svg";